import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-enter-tag-modal',
  templateUrl: './enter-tag-modal.component.html',
  styleUrls: ['./enter-tag-modal.component.scss'],
})
export class EnterTagModalComponent implements OnInit {
  @Input() title: string = this.translate.instant('cutbank_landing.enterTagId');
  @Input() placeHolder: string = this.translate.instant('cutbank_landing.enterId');
  @Input() inputType: 'text' | 'number' = 'text';
  input: string = '';
  constructor(private modalController: ModalController, private translate: TranslateService) {}

  ngOnInit(): void {}

  closeModal() {
    this.modalController.dismiss();
  }

  save() {
    if (this.input.length > 0) this.modalController.dismiss(this.input, 'SAVE');
  }
}
